
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/research/publication",
      function () {
        return require("private-next-pages/research/publication.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/research/publication"])
      });
    }
  